// extracted by mini-css-extract-plugin
module.exports = {"root":"EmptyColumn_root__3nQAi"};